<script>
export default {
  name: "HeroSectionComp",
  methods: {
    scrollTo(id) {
      const element = document.getElementById(id);
      if (element) {
        const offset = 80;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    },
  }
}
</script>

<template>
  <v-parallax src="https://www.enlight.mx/hubfs/photovoltaic-panels-in-front-of-city.jpg" height="100vh" class="hero-parallax">
    <section class="hero-section glass-effect">
      <div class="hero-dark-overlay"></div>
      <div class="hero-content">
        <h1 class="hero-title">Soluciones Energéticas Sostenibles</h1>
        <p class="hero-subtitle">Innovación y eficiencia para un futuro más verde</p>
        <div class="hero-actions">
          <v-btn
              color="white"
              variant="outlined"
              size="large"
              class="mr-4"
              @click="scrollTo('servicios')"
          >
            Nuestros Servicios
          </v-btn>
          <v-btn
              color="white"
              size="large"
              class="hero-primary-btn"
              @click="scrollTo('contacto')"
          >
            Contactar
          </v-btn>
        </div>
      </div>
    </section>
  </v-parallax>
</template>

<style scoped>
.hero-parallax {
  width: 100%;
}

.hero-section {
  position: relative;
  height: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  text-align: center;
  padding: 0;
  margin: 0;
}

.glass-effect {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  transform: translateZ(0);
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
  color: #0AB6A1;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 2rem;
  margin-bottom: 2.5rem;
  color: white;
  opacity: 0.9;
}

.hero-dark-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.hero-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.hero-primary-btn {
  background: linear-gradient(135deg, #0AB6A1 0%, #0C594B 100%) !important;
  transition: all 0.3s ease;
}

.hero-primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

@media (max-width: 960px) {
  .hero-title {
    font-size: 2.5rem;
  }

  .hero-subtitle {
    font-size: 1.5rem;
  }

  .hero-actions {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .hero-primary-btn,
  .hero-actions .v-btn {
    width: 100%;
    max-width: 250px;
  }
}

@media (max-width: 600px) {
  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1.2rem;
  }
}
</style>